module.exports = __webpack_public_path__ + "static/img/花瓶11.ae6c791.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/papercutLamp/imgs/花瓶11.png
// module id = bkKv
// module chunks = 2